import HomeCard from "../HomeCard";
import "./HomeCard4.css";

const HomeCard4 = () => {
    return <HomeCard className={"home-card-4"} itemType={"gather"} itemKey={0} itemName="장고버스" itemDesc="현실세계와 가상세계를 연결하는 데브메이트"/>
};

export default HomeCard4;
